import React, {FC, useEffect, useState} from 'react'
import {observer} from 'mobx-react'
import useStore from 'store'
import {useTranslation} from 'react-i18next'
import {Space} from '../../ui'
import { Switch } from '@material-ui/core'
import {
    ModalRow,
    InfoWrapper,
    ModalText,
    ConfirmButtonSm,
    ButtonGroup,
    DialogHeaderText
} from './styles'


export interface UserManagementFormState {
    isEnable: boolean
}

interface UserManagementSectionProps {
    currentOrgId: number | undefined
    resetForm: boolean
}


const UserManagementSection: FC<UserManagementSectionProps> = ({ currentOrgId, resetForm }) => {
    const {modulesStore, orgs: orgsStore} = useStore()
    const {t} = useTranslation('communitySettings')

    const [isFormChanged, setIsFormChanged] = useState<boolean>(false)
    const [module, setModule] = useState<any>(null)
    const [formState, setFormState] = useState<UserManagementFormState>({
        isEnable: false
    })

    useEffect(() => {
        const userManagementModule = modulesStore.communityFeatures.find(el => el.featureName === 'UserManagement')
        if (userManagementModule) {
            setModule(userManagementModule)
            setFormState({ isEnable: userManagementModule.enabled })
        } else {
            orgsStore.updateCommunity(currentOrgId, [...modulesStore.communityFeatures, {
                communityId: currentOrgId,
                enabled: false,
                featureName: 'UserManagement',
                id: 8,
                status: 2,
            }]).then(async () => {
                await modulesStore.getCommunityModulesAndFeatures(currentOrgId)
                const newModule = modulesStore.communityFeatures.find(el => el.featureName === 'UserManagement')
                if (newModule) {
                    setModule(newModule)
                    setFormState({ isEnable: newModule.enabled })
                }
            })
        }
    }, [currentOrgId])

    useEffect(() => {
        if (resetForm) onResetForm()
    }, [resetForm])

    useEffect(() => {
        setIsFormChanged(
            formState.isEnable !== (module?.enabled ?? false)
        )
    }, [formState, module])

    const Save = async () => {
        if (currentOrgId) {
            await orgsStore.updateCommunity(currentOrgId,
                modulesStore.communityFeatures.map(el => el.featureName === 'UserManagement' ? {
                    communityId: el.communityId,
                    enabled: formState.isEnable,
                    featureName: el.featureName,
                    id: el.id,
                    status: formState.isEnable ? 1 : 2,
                } : el),)

            await modulesStore.getCommunityModulesAndFeatures(currentOrgId)

            const userManagementModule = modulesStore.communityFeatures.find(el => el.featureName === 'UserManagement')
            if (userManagementModule) {
                setModule(userManagementModule)
                setFormState({ isEnable: userManagementModule.enabled })
            }
        }
    }

    const onResetForm = () => setFormState({
        isEnable: false
    })

    const ToggleEnable = (value: any) => setFormState({...formState, isEnable: value })

    return (
        <>
            <ModalRow>
               <DialogHeaderText>{`ניהול אוכלוסייה`}</DialogHeaderText>
               <ButtonGroup>
                 <ConfirmButtonSm disabled={!isFormChanged || module == null} onClick={Save} transparent>{t`save`}</ConfirmButtonSm>
               </ButtonGroup>
            </ModalRow>

            {module &&
                <>
                <ModalRow>
                    <InfoWrapper>
                        <ModalText>{t`isEnable`}:</ModalText>
                        <Space/>
                        <Switch
                            color="primary"
                            value={formState.isEnable}
                            onChange={({target}) => {
                                ToggleEnable(target.checked)
                            }}
                            checked={formState.isEnable}
                        />
                    </InfoWrapper>
                </ModalRow>
            </>
            }
            <Space/>
            <Space/>
        </>
    )
}

export default observer(UserManagementSection)
